import React from 'react'

import WaterUsageComponent from '../Components/WaterUsage/WaterUsageComponent'
import { useDeviceState } from '@context/device/context/device.context'

const WaterUsage: React.FC = () => {
  const { devices } = useDeviceState()

  return (
    <div>
      <WaterUsageComponent devices={devices} />
    </div>
  )
}

export default WaterUsage
